export default {
	SET_SUBCUSTOMERS: "SET_SUBCUSTOMERS",
	CREATE_SUBCUSTOMER: "CREATE_SUBCUSTOMER",
	SET_LOADING: "SET_LOADING",
	EDIT_SUBCUSTOMER: "EDIT_SUBCUSTOMER",
	REMOVE_SUBCUSTOMER: "REMOVE_SUBCUSTOMER"
}
